import React, {useContext} from 'react';
import {Button, Header, Icon, Item, Label, Loader, Segment} from 'semantic-ui-react';
import {observer} from 'mobx-react-lite';
import {Link} from 'react-router-dom';
import {RootStoreContext} from '../../../core/stores/rootStore';
import {ClientGoalStatus, ClientGoalType, IClientGoal} from "../../../core/models/clientGoals";
import moment from "moment";
import DateTimePickerWithShortcuts from "../../commom/date/DateTimePickerWithShortcuts";
import ClientGoalMet from "../commom/ClientGoalMet";
import {FiCheck, HiOutlineX, IoMdCheckmarkCircleOutline} from "react-icons/all";
import {semanticColorToHash} from "../../../core/common/util/semanticUi";

const activityImageTextStyle = {
    position: 'absolute',
    bottom: '5%',
    left: '5%',
    width: '100%',
    height: 'auto',
    color: 'white'
};

const editButtonText = (type: ClientGoalType): string => {
    const prefix = 'Izmeni '
    
    switch (type) {
        case ClientGoalType.payment:
            return prefix + 'naplatu'
        case ClientGoalType.clientRequest:
            return prefix + 'zahtev klijenta'
        case ClientGoalType.classic:
            return prefix + 'cilj'
    }
}

const ClientGoalHeader: React.FC<{ clientGoal: IClientGoal }> = ({
                                                                     clientGoal
                                                                 }) => {
    const rootStore = useContext(RootStoreContext);
    const {currentTraffic} = rootStore.trafficsStore
    const {
        updateDate
    } = rootStore.clientGoalsStore

    return (
        <Segment.Group>
            <Segment
                basic
                attached='top'
                className={`${clientGoal.color}Background`}
                style={{height: '20em'}}>


                <Label
                    style={{backgroundColor: 'transparent'}}
                    attached='top right'
                >
                    {clientGoal.status === ClientGoalStatus.met ?

                        <IoMdCheckmarkCircleOutline
                            color='#08db0c'
                            size='10em'/> :
                        clientGoal.status === ClientGoalStatus.partlyMet ?
                            <FiCheck
                                color={semanticColorToHash('grey')}
                                size='10em'/> :
                            clientGoal.status === ClientGoalStatus.failed ?
                                <HiOutlineX
                                    color={semanticColorToHash('red')}
                                    size='10em'/> :
                                null
                    }

                </Label>

                <Segment style={activityImageTextStyle} basic>
                    <Item.Group>
                        <Item>
                            <Item.Content>
                                <Header
                                    size='huge'
                                    content={clientGoal.name}
                                    style={{color: 'white'}}
                                />
                                <p>
                                    <strong>
                                        {clientGoal.category}
                                    </strong>
                                </p>
                                {clientGoal.date &&
                                <p>{moment(clientGoal.date).format('l')}</p>}
                                {/*<p>*/}
                                {/*    Hosted by{' '}*/}
                                {/*    <Link to={`/profile/${host.username}`}>*/}
                                {/*        <strong>{host.displayName}</strong>*/}
                                {/*    </Link>*/}
                                {/*</p>*/}
                            </Item.Content>
                        </Item>
                    </Item.Group>
                </Segment>
            </Segment>
            <Segment clearing attached>
                <ClientGoalMet clientGoal={clientGoal}/>

                <Button
                    as={Link}
                    to={`/${currentTraffic?.id}/clientGoals/manage/${clientGoal.id}/edit?type=${clientGoal.type}`}
                    color='orange'
                    floated='right'
                >
                    <Icon name='edit'/>
                    {editButtonText(clientGoal.type)}
                </Button>
            </Segment>

            <Segment attached='bottom'>
                <Header
                    color='grey'
                    as='h4'>Datum zavrsetka <Loader size='mini' inline active={clientGoal.flags?.updating}/></Header>
                <DateTimePickerWithShortcuts
                    shortcuts={{
                        today: true,
                        tomorrow: true,
                        nextWeek: true
                    }}
                    date={clientGoal.completedDate ? moment(clientGoal.completedDate) : null}
                    disabled={clientGoal.flags?.updating}
                    onChange={(date) => {
                        updateDate(clientGoal.id, 'completed', date ? date.format('YYYY-MM-DD') : null)
                    }}
                />
            </Segment>
        </Segment.Group>
    );
};

export default observer(ClientGoalHeader);